import axios from 'axios';
import Literals from '../../helpers/Literals'
import { authenticateRequest } from '../../helpers/utils';


export const fetchFacility = () => async dispatch => {
  dispatch({ type: 'FETCH_FACILITY' });
  try {
    const { data } = await axios.get(`${Literals.BASE_API}users/backend/organizations/?page=1&page_size=50`);

    dispatch({ type: 'FETCH_FACILITY_SUCCESS', payload: data.results, next_page:data.next, count:data.count});
  } catch (e) {
    authenticateRequest(e)
    dispatch({ type: 'FETCH_FACILITY_FAILURE', payload: e.response?e.response.data.details:Literals.ERROR_OCCURED, });
  }
};

export const getFacility = (id) => async dispatch => {
  dispatch({ type: 'FETCH_FACILITY_PROFILE' });
  try {
    const { data } = await axios.get(`${Literals.BASE_API}professional/backend/${id}/`);
    dispatch({ type: 'FETCH_FACILITY_PROFILE_SUCCESS', payload: data.results });
  } catch (e) {
    dispatch({ type: 'FETCH_FACILITY_PROFILE_FAILED', payload: e.response?e.response.data.details:Literals.ERROR_OCCURED, });
  }
};

